import React, { useEffect } from 'react';
import { Spinner, TopBar, Body, Content, Navigation, Cookies, ErrorBoundary, MainErrorBoundary, SystemNotificationPopup } from '@ers/ui';
import moment from 'moment';
import 'moment/locale/pl';
import { Switch, Route } from 'react-router';

import { LayoutHelper } from '@ers/helpers';
import { Log } from 'oidc-client';
import { SentryLogger } from '@ers/errors/';
import {
    RoutingContainer,
    StoreContainer,
    LayoutContainer,
    MenuStateContextContainer
} from './containers';
import { Home } from './home';
import { Confirm } from './confirm';
import { Deny } from './deny';
import { Settings } from './settings';
import { Form } from './form';
import { Messages } from './messages';
import { PageNotFound } from './pageNotFound';
import { ServerError } from './serverError';
import { Toasts } from './toasts/Toasts';
import { Components as Auth } from './authorization';
import { RouteHelper } from './shared/helpers';
import { MenuItemTypes } from './shared/data';





const App = () => {
    useEffect(() => {
        LayoutHelper.calculateVH();
        moment.locale('pl');
        Log.logger = SentryLogger;
        Log.level = Log.ERROR;
    }, []);

    return (
        <div className="App">
            <MainErrorBoundary>
                <MenuStateContextContainer>
                    <StoreContainer>
                        <RoutingContainer>
                            <ErrorBoundary>
                                <Auth.AuthorizationProvider>
                                    <TopBar />
                                    <LayoutContainer>
                                        <Navigation />
                                        <Content>
                                            <SystemNotificationPopup />
                                            <React.Suspense
                                                fallback={(
                                                    <Body>
                                                        <Spinner.Plate />
                                                    </Body>
                                                )}
                                            >
                                                <ErrorBoundary>
                                                    <Switch>
                                                        <Route exact path={RouteHelper.getPathByType(MenuItemTypes.Home)} component={Home} />
                                                        <Route exact path={`${RouteHelper.getPathByType(MenuItemTypes.Messages)}/:threadId?`} component={Messages} />
                                                        <Route exact path={`${RouteHelper.getPathByType(MenuItemTypes.Form)}/:applicationId/:archive?`} component={Form} />
                                                        <Route exact path={RouteHelper.getPathByType(MenuItemTypes.ConfirmApplication)} component={Confirm} />
                                                        <Route exact path={RouteHelper.getPathByType(MenuItemTypes.DenyApplication)} component={Deny} />
                                                        <Route exact path={RouteHelper.getPathByType(MenuItemTypes.Settings)} component={Settings} />
                                                        <Route exact path={RouteHelper.getPathByType(MenuItemTypes.Archive)} component={Home} />
                                                        <Route exact path={RouteHelper.getPathByType(MenuItemTypes.ServerError)} component={ServerError} />
                                                        <Route component={PageNotFound} />
                                                    </Switch>
                                                </ErrorBoundary>
                                            </React.Suspense>
                                        </Content>
                                    </LayoutContainer>
                                    <Cookies />
                                    <Toasts />
                                </Auth.AuthorizationProvider>
                            </ErrorBoundary>
                        </RoutingContainer>
                    </StoreContainer>
                </MenuStateContextContainer>
            </MainErrorBoundary>
        </div>
    );
};
export default App;
